// Textos del programa de referidos (referrals). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'es',
  data: {
    REFERRALS: {
      ACTIONS: {
        RELOAD: 'Recargar',
        LOADING: 'Cargando...',
        NEW_LINK: 'Nuevo link',
        APPLY: 'Aplicar',
        RETRY: 'Reintentar',
        LINK: 'Link',
        VIEW_LINKS: 'Ver links',
        SAVE: 'Guardar',
        SAVING: 'Guardando…',
        CANCEL: 'Cancelar',
        BONUS: 'Bonificación',
        ACTIVATE: 'Activar',
        DEACTIVATE: 'Desactivar',
        ACTIVATING: 'Activando…',
        DEACTIVATING: 'Desactivando…',
        PREVIOUS: 'Anterior',
        NEXT: 'Siguiente',
        FIRST_PAGE: 'Primera página',
        LAST_PAGE: 'Última página',
        CHANGE: 'Cambiar',
        CLOSE: 'Cerrar',
        CREATE_LINK: 'Crear link',
        CREATING: 'Creando...',
      },
      RANGE: {
        ARIA: 'Periodo',
        DAYS: '{{n}} días',
        ALL: 'Todo',
        FROM: 'Desde',
        TO: 'Hasta',
      },
      FUNNEL: {
        ARIA: 'Embudo de referidos',
        LOADING: 'Cargando embudo',
        REDEEMED: 'Canjes',
        REGISTERED: 'Registrados',
        COMPLETED: 'Completados',
        CONV_TOOLTIP: 'Sobre la etapa anterior',
        LINKS_CREATED_ONE: 'link creado',
        LINKS_CREATED_OTHER: 'links creados',
        PAID: 'pagados',
        REDEMPTIONS_ONE: '{{n}} canje',
        REDEMPTIONS_OTHER: '{{n}} canjes',
        DEFAULT_PREFIX: 'Por defecto',
        DEFAULT_SUFFIX: 'por parte',
      },
      STATUS: {
        TITLE: 'Estado actual de los canjes',
        HINT: 'La cohorte va por fecha de canje y el estado es el de hoy. Lo pagado se mide por fecha de pago.',
        PENDING_REGISTRATION: 'Pendientes de registro',
        REGISTERED_UNPAID: 'Registrados sin cobrar',
        COMPLETED: 'Completados',
        EXPIRED: 'Caducados',
      },
      OWNERS: {
        TITLE: 'Invitadores',
        SUBTITLE: 'Usuarios que han generado links de invitación. Pulsa «Ver links» para ver y editar sus links.',
        SEARCH_PLACEHOLDER: 'Buscar invitador por nombre, apellidos o email',
        SEARCH_ARIA: 'Buscar invitadores',
        CLEAR_SEARCH: 'Borrar búsqueda',
        ONLY_WITH_REDEMPTIONS: 'Solo con canjes',
        LOADING: 'Cargando invitadores',
        EMPTY: 'Todavía no hay nadie que haya generado un link de invitación.',
        COL_OWNER: 'Invitador',
        COL_LINKS: 'Links',
        COL_REDEMPTIONS: 'Canjes',
        COL_PENDING: 'Pendientes',
        COL_REGISTERED: 'Registrados',
        COL_COMPLETED: 'Completados',
        COL_EXPIRED: 'Caducados',
        COL_PAID: 'Pagado',
        COL_LAST_LINK: 'Último link',
        COL_ACTIONS: 'Acciones',
        ACTIVE_COUNT_ONE: '{{n}} activo',
        ACTIVE_COUNT_OTHER: '{{n}} activos',
        PAGINATION_ONE: 'Mostrando {{shown}} de {{total}} invitador',
        PAGINATION_OTHER: 'Mostrando {{shown}} de {{total}} invitadores',
        ROWS_PER_PAGE: 'Filas por página',
        ROWS_PER_PAGE_OPTION: '{{n}} filas',
      },
      LINKS: {
        LOADING: 'Cargando links...',
        EMPTY: 'Este usuario no tiene ningún link.',
        ACTIVE: 'Activo',
        INACTIVE: 'Desactivado',
        CAMPAIGN: 'Campaña',
        CREATED_ON: 'Creado el {{date}}',
        COPY: 'Copiar link',
        COPIED: 'Link copiado',
        REDEMPTIONS_ONE: 'canje',
        REDEMPTIONS_OTHER: 'canjes',
        PENDING_SHORT: '{{n}} pend.',
        REGISTERED_SHORT: '{{n}} reg.',
        COMPLETED_SHORT: '{{n}} compl.',
        EXPIRED_SHORT: '{{n}} cad.',
        PAGER_SHOWING: 'Mostrando',
        PAGER_OF: 'de',
        PAGER_LINKS_ONE: 'link',
        PAGER_LINKS_OTHER: 'links',
        NOTE: 'Cambiar la bonificación afecta solo a los canjes nuevos: a quien ya canjeó se le paga lo que se le prometió. Desactivar un link corta los canjes nuevos y deja seguir a los que ya estaban en marcha.',
      },
      BONUS: {
        REFERRED: 'Invitado',
        OWNER: 'Invitador',
        REFERRED_EUR: 'Invitado (€)',
        OWNER_EUR: 'Invitador (€)',
        DEFAULT: 'Por defecto',
        DEFAULT_BONUS: 'Bonificación por defecto',
      },
      MODAL: {
        TITLE: 'Nuevo link de invitación',
        SUBTITLE: 'El link es de un usuario concreto: lo que gane su invitado y él salen de aquí.',
        USER: 'Usuario',
        USER_PLACEHOLDER: 'Nombre, apellidos o email',
        MIN_CHARS: 'Escribe al menos dos letras para buscar.',
        SEARCHING: 'Buscando...',
        NO_RESULTS: 'Ningún usuario con ese nombre o email.',
        NOTE: '0 € es un importe válido: significa que esa parte no cobra. El importe queda congelado en cada canje, así que editarlo después no cambia lo que cobra quien ya canjeó.',
      },
      MESSAGES: {
        INVALID_AMOUNTS: 'Revisa los importes: tienen que ser números de 0 € en adelante.',
        BONUS_UPDATED: 'Bonificación actualizada. Afecta a los canjes nuevos.',
        LINK_ACTIVATED: 'Link activado.',
        LINK_DEACTIVATED: 'Link desactivado. Los canjes que ya estaban en marcha siguen su curso.',
        COPY_FAILED: 'No se ha podido copiar el link.',
        PICK_USER: 'Elige el usuario al que pertenece el link.',
        LINK_CREATED: 'Link creado. Ya se puede compartir.',
        NO_PERMISSION: 'No tienes permiso para gestionar el programa de referidos.',
        LOAD_ERROR: 'No se han podido cargar los datos. Inténtalo de nuevo.',
      },
      DIAGNOSIS: {
        TAB: 'Referidos',
        TITLE: 'Referidos',
        REFRESH: 'Actualizar',
        RETRY: 'Reintentar',
        LOAD_ERROR: 'No se han podido cargar los referidos.',
        DELETED_ON: 'borrada el {{date}}',
        ACTIVE: 'activa',
        SAME_PERSON: 'misma persona',
        OTHER_PERSON: 'otra persona',
        EARNED_INVITING: 'Ganado invitando',
        EARNED_INVITED: 'Ganado al ser invitado',
        PROGRAM: 'Programa actual',
        PROGRAM_VALUE: '{{amount}} · {{trips}} viajes',
        INVITEE: {
          TITLE: 'Cómo entró',
          INVITED_BY: 'invitado por',
          no_link: { TITLE: 'Sin enlace', TEXT: 'no entró por ningún enlace de invitación' },
          paid: { TITLE: 'Pagado', TEXT: 'el {{date}}' },
          pending: {
            TITLE: 'Pendiente',
            TEXT: 'aún no se ha pagado',
            TEXT_VERIFY: 'falta verificar su identidad',
            TEXT_TRIPS: '{{done}}/{{required}} trayectos',
          },
          lost_account_deleted: {
            TITLE: 'Canje perdido',
            TEXT: 'la cuenta del canje se borró el {{date}}',
            TEXT_NO_DATE: 'la cuenta del canje está borrada',
          },
          inviter_account_deleted: {
            TITLE: 'Invitador borrado',
            TEXT: 'quien le invitó borró su cuenta el {{date}}',
            TEXT_NO_DATE: 'quien le invitó borró su cuenta',
          },
          expired: { TITLE: 'Caducado', TEXT: 'el canje caducó' },
        },
        INVITER: {
          TITLE: 'Sus invitados',
          EMPTY: 'Ninguno',
          NO_ACCOUNT: 'Sin cuenta',
          CAME_BACK: 'Volvió con otra cuenta:',
          PHONE_OTHER_PERSON: 'Ahora usa su teléfono:',
          OLD_PROGRAM: 'programa anterior',
          TIP_NOT_LISTED: 'Si pregunta por alguien que no aparece aquí, esa persona no se registró con su enlace.',
        },
        STEP: { DELETED: 'Cuenta borrada', LINK: 'Enlace', REGISTERED: 'Registrado', VERIFIED: 'Verificado', TRIPS: 'Viajes', PAID: 'Pagado', SUB_REJECTED: '{{count}} rechazados', SUB_DELETED: 'borrada {{date}}', SUB_NOT_REQUIRED: 'no hace falta' },
        VIEW: { ARIA: 'Cómo ver los invitados', BOARD: 'Tablero', LIST: 'Lista' },
        BOARD: { DONE: 'Completados', PROGRESS: 'En proceso', OUT: 'Perdidos' },
        TAG: {
          PAID: 'Pagado',
          TRIPS: 'Viajes {{done}} de {{required}}',
          LAST_TRIP: 'último {{date}}',
          VERIFY: 'Falta verificar',
          REJECTED: '{{count}} rechazados',
          SIGN_UP: 'Falta registrarse',
          LINK_ON: 'enlace {{date}}',
          DELETED: 'Borrada {{date}}',
          DELETED_NO_DATE: 'Cuenta borrada',
          EXPIRED: 'Caducada',
        },
        GROUP: { PAID: 'Completados', IN_PROGRESS: 'En proceso', LOST: 'Cuenta borrada', EXPIRED: 'Caducados' },
        FLAGS: {
          TITLE: 'Avisos',
          OTHER: 'Aviso: {{code}}',
          multiple_accounts_same_phone: '{{count}} cuentas con su teléfono',
          dni_in_other_account: 'DNI en {{count}} cuentas más',
          phone_used_by_other_person: 'teléfono usado por otra persona',
          inviter_account_deleted: 'invitador borrado',
        },
      },
    },
  },
};
